<template>
    <header class="gz-header">
        <div class="gz-header__container gz-page__width">
            <GZ-Logo/>
            <gz-top-menu></gz-top-menu>
            <GZ-AuthMenu v-if="$store.getters['authToken']"/>
        </div>
    </header>
</template>

<script>
export default {
    name: 'Header'
}
</script>